module.exports = __webpack_public_path__ + "img/sociesc-branco.946c44cb.svg";